//PATRICK
class Overseer{
    constructor(){
        console.log("You shouldn't be doing this...");
    }
    static attachListeners(channel){
        var listeners = document.querySelectorAll(`[data-listen_channels='${channel}']`);
        return listeners;
    }
    static attachListenersWithinParent(channel, parent){
        var listeners = parent.querySelectorAll(`[data-listen_channels='${channel}']`);
        return listeners;
    }
}

class VariantItem extends HTMLElement{
    constructor(){
        super();
    }
    uncheck(){
        this.classList.remove("bordered");
    }
    watchOut(){
        if(!this.input ){
            this.input = this.querySelector("input");
            setTimeout(() => {
                this.watchOut();
            }, 10);
        }
        else{         
            if (this.input.checked){
                this.parentElement.querySelectorAll("variant-item").forEach((element) => {element.uncheck()});
                this.classList.add("bordered");
            }
            else{
                this.uncheck();
            }
        }
    }
    connectedCallback(){
        this.watchOut();
        this.addEventListener("click", () => {
            this.watchOut();
        });
    }
}
if(!window.customElements.get("variant-item")){
    window.customElements.define("variant-item", VariantItem);
}

class Pickle extends HTMLElement{
    constructor(){
        super();
    }

    heyListen(){
        this.targetParent = this.parentElement.parentElement;
        this.targetAnchor = Overseer.attachListenersWithinParent(this.channels[0], this.targetParent)[0];
        this.targetImgContainer = Overseer.attachListenersWithinParent(this.channels[1], this.targetParent)[0];
        this.targetTitle = Overseer.attachListenersWithinParent(this.channels[2], this.targetParent)[0];
        if(!this.targetAnchor || !this.targetImgContainer || !this.targetTitle){
            setTimeout(() => this.heyListen(), 500);
        }
        else{
            this.addEventListener("click", () => {
                var timestamp = new Date().getTime();
                this.targetTitle.innerHTML = `<span>${this.dataset.product_title}</span>`;
                this.targetImgContainer.querySelector("img").src = this.dataset.product_image + "&t=" + timestamp;
                this.targetImgContainer.querySelector("img").srcset = "";
                this.targetAnchor.href = this.dataset.product_link;
            });
        }
    }

    connectedCallback(){
        this.channels = this.dataset.broadcast_channels.split(' ');
        this.heyListen();
    }
}
if(!window.customElements.get("color-pickle")){
    window.customElements.define("color-pickle", Pickle);
}

class GliderController extends HTMLElement{
    constructor(){
        super();
    }
    connectedCallback(){
        this.target = this.previousElementSibling;
        if(window.matchMedia("only screen and (max-width:810px").matches){
            this.perView = 1;
            this.autoplay = 1;
            this.animationTimingFunction = 'ease';
            this.animationDuration = 5000;
        }
        else{
            this.autoplay = 1;
            this.animationDuration = 5000;
            this.perView = this.dataset.slides_per_view;
            this.animationTimingFunction = 'linear';
        }
        this.glider = new Glide(this.target, {
            type: 'carousel',
            autoplay: this.autoplay,
            animationTimingFunc: this.animationTimingFunction,
            perView: this.perView,
            animationDuration: this.animationDuration
        });

        this.glider.mount();
    }
}
if(!window.customElements.get("glider-controller")){
    window.customElements.define("glider-controller", GliderController);
}
class PagePainter extends HTMLElement{
    constructor(){
        super();
    }
    
    heyListen(){
        this.target = document.getElementById("layout-wrapper");
        if(!this.target){
            console.log("not found");
            setTimeout(() => {this.heyListen()}, 500);
            return;
        }
        this.target.style.setProperty("--custom-bg", this.dataset.background);
        this.target.style.setProperty("--custom-tg", this.dataset.text);
        this.target.classList.add("personalized-colors", "custom");
    }

    connectedCallback(){
        this.heyListen();
    }
}
if(!window.customElements.get("page-painter")){
    window.customElements.define("page-painter", PagePainter);
}
//ENHANCED AND EXPANDED
class FullyExpand extends HTMLElement{
    constructor(){
        super();
    }

    attachContent(){
        this.overlay = this.querySelector('.overlay');
        if(!this.overlay){
            setTimeout(() => {
                this.attachContent();
            }, 50);
        }
        else{
            this.video = this.querySelector('video');
            this.overlay.addEventListener("click", () => {
                var destination = document.getElementById(`thinking-box-${this.dataset.sectionid}`);
                this.video.controls = true;
                this.video.muted = false;
                this.video.volume = 0.5;
                destination.appendChild(this.video);
                destination.classList.remove('hidden-by-default');
                destination.classList.add('flex-row');
                destination.dataset.blockid = this.dataset.blockid;
            });
        }
        return;
    }
    connectedCallback(){
        if(this.dataset.is === 'video'){
            this.attachContent();
        }
    }
}if(!window.customElements.get("fully-expand")){
    window.customElements.define("fully-expand", FullyExpand);
}
class ShrinkBack extends HTMLElement{
    constructor(){
        super();
    }

    connectedCallback(){
        this.addEventListener("click", () => {
            var video = this.querySelector('video');
            var target = document.getElementById(`amwt-mediabox-${this.dataset.blockid}`);
            video.muted = true;
            video.controls = false;
            target.appendChild(video);
            this.classList.remove('flex-row')
            this.classList.add('hidden-by-default');
            this.dataset.blockid = "";
        })
    }
}
if(!window.customElements.get("shrink-back")){
    window.customElements.define("shrink-back", ShrinkBack);
}
